/* CAMPAIGN MEDIA BUYER DATA */
export const GET_CAMPAIGN_MEDIA_BUYERS_LIST = "GET_CAMPAIGN_MEDIA_BUYERS_LIST"
export const SET_CAMPAIGN_MEDIA_BUYERS_LIST = "SET_CAMPAIGN_MEDIA_BUYERS_LIST"

/* USERS INFO */
export const SET_CAMPAIGN_MEDIA_BUYER_USERS_INFO = "SET_CAMPAIGN_MEDIA_BUYER_USERS_INFO"

/* CAMPAIGNS MEDIA BUYER ACTIONS */
export const ADD_CAMPAIGN_MEDIA_BUYERS = "ADD_CAMPAIGN_MEDIA_BUYERS"
export const DELETE_CAMPAIGN_MEDIA_BUYERS = "DELETE_CAMPAIGN_MEDIA_BUYERS"

/* CAMPAIGN MEDIA BUYER PROFILE DATA */
export const GET_CAMPAIGN_MEDIA_BUYER_PROFILE = "GET_CAMPAIGN_MEDIA_BUYER_PROFILE"
export const SET_CAMPAIGN_MEDIA_BUYER_PROFILE = "SET_CAMPAIGN_MEDIA_BUYER_PROFILE"
export const UPDATE_CAMPAIGN_MEDIA_BUYER_PROFILE = "UPDATE_CAMPAIGN_MEDIA_BUYER_PROFILE"
export const SET_ERROR_CAMPAIGN_MEDIA_BUYER_PROFILE = "SET_ERROR_CAMPAIGN_MEDIA_BUYER_PROFILE"

/* LOADER */
export const SHOW_CAMPAIGN_MEDIA_BUYERS_LOADER = "SHOW_CAMPAIGN_MEDIA_BUYERS_LOADER"
export const HIDE_CAMPAIGN_MEDIA_BUYERS_LOADER = "HIDE_CAMPAIGN_MEDIA_BUYERS_LOADER"